import { z } from 'zod';

export const relatedTermSchema = z.object({
  fields: z.object({ displayName: z.string() }),
});
